import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { v4 } from 'uuid';
import {
  AuthenticationService,
  LoginStatus,
} from '../services/authentication.service';
import { isNullOrEmpty } from '../utils/common-functions';
import { Log } from './../models/log';
import { AUTHENTICATION_SERVICE } from './../services/authentication.service';

import * as _ from 'lodash';
import { AppContext } from '../../common/models/app-context';
import { LogType } from '../../rt-shared/enums';
import { UserTraceLogService } from '../../rt-shared/services';
import { ErrorService } from '../error';
import { UserProfileService } from '../services/user-profile.service';

@Injectable()
export class ApimInterceptor implements HttpInterceptor {
  constructor(
    @Inject(AUTHENTICATION_SERVICE)
    private authenticationService: AuthenticationService,
    private userProfileService: UserProfileService,
    private _appContext: AppContext,
    private _userTraceLogService: UserTraceLogService,
    private errorService: ErrorService
  ) { }
  azureAD = globalThis.sigv.appContext.envConfig?.azureAD;
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (globalThis.sigv.appContext.sigvRetailConfig.disableHttpInterceptor) {
      return next.handle(request);
    }
    if (this.apimFilter(request.url) || true) {
      const checkLoginStatus = async (): Promise<boolean> => {
        const loginStatus = await this.authenticationService.getLoginStatus();
        return new Promise((resolve) => {
          resolve(loginStatus === LoginStatus.LoginSuccess);
        });
      };
      if (
        this.azureAD?.enabled &&
        isNullOrEmpty(this.authenticationService.idToken)
      ) {
        checkLoginStatus().then((result) => {
          this._userTraceLogService.setTraceLog(LogType.BUSINESS_CHECK, {
            userStatus: result,
          });
        });
      }
      const clientTraceId =
        request.body instanceof Log
          ? (request.body as Log).clientTraceId
          : v4();
      request = request.clone({
        setHeaders: {
          'X-UserNo': this.userProfileService.userNo ?? '',
          'X-From-Channel': globalThis.sigv.appContext.projectConfig.systemCode,
          'X-Client-TraceId': clientTraceId,
          'X-Client-Date': new Date().toISOString(),
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Methods':
            'GET, PUT, POST, DELETE, OPTIONS, PATCH',
          'Access-Control-Max-Age': '86400',
          ...(!isNullOrEmpty(this.authenticationService.idToken) &&
            this.azureAD?.enabled && {
            Authorization: 'Bearer ' + this.authenticationService.idToken,
          }),
          ...(!isNullOrEmpty(this.authenticationService.idToken) &&
            (globalThis.sigv.appContext.envConfig as any)
              ?.isUseSubmissionToken && {
            Authorization: 'Bearer ' + this.authenticationService.idToken,
          }),
          ...(!isNullOrEmpty(this.userProfileService.email) &&
            !this.azureAD?.enabled && {
            Username: this.userProfileService.email,
          }),
        },
      });
    }
    const useLog = {} as any;
    const uri = request.url.split('/');
    useLog[_.last(uri) ?? 'REQUEST'] = request;
    this._userTraceLogService.setTraceLog(LogType.HTTP_REQUEST, useLog);
    return next.handle(request);
  }

  private apimFilter(uri: string): boolean {
    return uri.includes(this._appContext.envConfig?.apiUrls?.['apimUriFilter']);
  }
}
